<template>
  <div class="auth-loader">
    <v-progress-circular indeterminate size="36" width="3" />
  </div>
</template>

<script>
export default {
  name: "AuthLoader",
};
</script>

<style>
.auth-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
</style>
